import { Col, Container } from '@ag1/ui';
import clsx from 'clsx';
import { HeroHalfTest as HeroHalfTestProps, SanityKeyed } from 'types/studio/studio';
import styles from './HeroHalfTest.module.scss';
import HeroHalfTestContent from './HeroHalfTestContent/HeroHalfTestContent';
import HeroHalfTestMedia from './HeroHalfTestMedia/HeroHalfTestMedia';
import { CommonSectionProps } from '../types';

const HeroHalfTest = (props: SanityKeyed<HeroHalfTestProps> & CommonSectionProps) => {
  const {
    _key: key,
    _type: sectionType,
    headline,
    text,
    caption,
    captionIcon,
    unifiedButton,
    unifiedButton2,
    media,
    backgroundColor,
    ratingValue,
    ratingTitle,
    isBtnUnderText,
    badgesOptions,
    contentPosition = 'left',
    visibleOnPageLoad
  } = props;

  return (
    <div
      className={clsx(
        styles.root,
        backgroundColor === 'stone' && styles.bgStone,
        backgroundColor === 'white' && styles.bgWhite,
        contentPosition === 'left' && styles.reverse
      )}
      id={key}>
      <Col className={styles.noPadding} span={{ xxs: 12, m: 6 }}>
        <HeroHalfTestMedia
          media={media}
          contentPosition={contentPosition}
          visibleOnPageLoad={visibleOnPageLoad}
        />
      </Col>
      <Col
        className={clsx(styles.colContent, styles.noPadding)}
        span={{ xxs: 12, m: 6, xl: 5 }}
        offset={{ xl: contentPosition === 'left' ? 0 : 1 }}>
        <Container className={contentPosition === 'left' ? styles.clearRight : styles.clearLeft}>
          <HeroHalfTestContent
            sectionType={sectionType}
            headline={headline}
            text={text}
            unifiedButton={unifiedButton}
            unifiedButton2={unifiedButton2}
            caption={caption}
            captionIcon={captionIcon}
            contentPosition={contentPosition}
            ratingValue={ratingValue}
            ratingTitle={ratingTitle}
            isBtnUnderText={isBtnUnderText}
            badgesOptions={badgesOptions}
            visibleOnPageLoad={visibleOnPageLoad}
          />
        </Container>
      </Col>
    </div>
  );
};

export default HeroHalfTest;
